/**
* Represent a task to be performed
*/
export class ChartTask {
  constructor(public action: number, public object_name?: string, public id?: any, public object?: any) {
  }
}
